import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLocationDropPininline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("path", { d: "M32 61s20-24.152 20-38.772C52 11.608 43.046 3 32 3s-20 8.609-20 19.228C12 36.848 32 61 32 61z" }), /* @__PURE__ */ _jsx("path", { d: "M32 29a6 6 0 1 0 0-12 6 6 0 0 0 0 12z" })]
	})
});
export default SvgLocationDropPininline;
